import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { REPLACE_DEPARTMENT_FIELDS } from './utils';
import { structureList } from '../accountManage/request';
import { getTreeName, getApplication, getIntermediary, getCustomer } from './request';
export default {
  name: 'data-authority-department',
  props: {
    authorityType: {
      type: Number
    }
  },
  data() {
    return {
      REPLACE_DEPARTMENT_FIELDS,
      departmentVisible: false,
      // 数据权限部门弹窗状态
      //  选择数据范围表单
      dataScopeForm: {
        departmentValue: '',
        applicationValue: '',
        intermediaryValue: '',
        customerValue: ''
      },
      departmentSelectList: [],
      applicationSelectList: [],
      customerSelectList: [],
      intermediarySelectList: [],
      continueState: false,
      currentAuthorityRow: {
        permissionsId: null,
        arrId: null,
        currentAuthorityTypeValue: null
      },
      toSaveTableData: [],
      saveType: '',
      structureName: '',
      continueVisible: true,
      tag: this.$props.authorityType,
      changeSaveRes: false
    };
  },
  watch: {
    authorityType(newV) {
      this.tag = newV;
    }
  },
  computed: {
    DATA_SCOPE_RULES() {
      return {
        departmentValue: [{
          required: true,
          message: this.$t('请选择部门'),
          trigger: 'change'
        }],
        applicationValue: [{
          required: true,
          message: this.$t('请选择') + this.$t('应用'),
          trigger: 'change'
        }]
      };
    },
    showSeeApplication() {
      if (this.currentAuthorityRow.permissionsId === 470 && (this.currentAuthorityRow.currentAuthorityTypeValue === 3 || this.currentAuthorityRow.currentAuthorityTypeValue === 4)) {
        return false;
      } else {
        return true;
      }
    },
    showCustomerValue() {
      if ((this.tag == 1 || this.tag === 2) && this.currentAuthorityRow.permissionsId !== 470 && !(this.currentAuthorityRow.currentAuthorityTypeValue === 3 || this.currentAuthorityRow.currentAuthorityTypeValue === 4)) {
        return true;
      } else {
        return false;
      }
    },
    showIntermediary() {
      if (this.tag == 1 && (this.currentAuthorityRow.permissionsId !== 470 || !(this.currentAuthorityRow.currentAuthorityTypeValue === 3 || this.currentAuthorityRow.currentAuthorityTypeValue === 4))) {
        return true;
      } else {
        return false;
      }
    },
    showEmpty() {
      if (this.currentAuthorityRow.currentAuthorityTypeValue === 4 && this.currentAuthorityRow.permissionsId === 470) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    // 根据对应tag获取下拉列表数据
    async getEditInfo() {
      let tag = this.tag ? this.tag : this.$props.authorityType;
      let params = {
        customerId: Number(this.$route.params.id.split(',')[1])
      };
      const application = await getApplication(params);
      this.applicationSelectList = application;
      if (tag == 1) {
        let intermediaryParams = Object.assign(JSON.parse(JSON.stringify(params)), {
          type: 0
        });
        const intermediary = await getIntermediary(intermediaryParams);
        this.intermediarySelectList = intermediary;
      } else {
        this.intermediarySelectList = [];
      }
      if (tag == 1 || tag == 2) {
        const customer = await getCustomer(params);
        this.customerSelectList = customer;
      } else {
        this.customerSelectList = [];
      }
    },
    async openModal(row, type, tableData) {
      this.emptyForm();
      this.currentAuthorityRow = row;
      // debugger
      this.currentAuthorityRow.currentAuthorityTypeValue = row.authorityTypeValue;
      this.saveType = type;
      this.toSaveTableData = tableData;
      await this.getDepartmentAndApplicationData();
      await this.getEditInfo();
      if (type === 'edit') {
        this.continueVisible = false;
        this.getEditDetails(row);
      } else {
        this.continueVisible = true;
      }
      this.departmentVisible = true;
    },
    // 获取编辑详情
    getEditDetails(row) {
      this.dataScopeForm.departmentValue = row.structureId;
      this.dataScopeForm.applicationValue = row.applicationId;
      this.dataScopeForm.customerValue = row.customerId;
      this.dataScopeForm.intermediaryValue = row.agencyId;
    },
    // 保存当前权限表单
    async onSaveAuthorityForm() {
      await this.getStructureName();
      this.$refs.dataScopeRef && this.$refs.dataScopeRef.validate(valid => {
        if (valid) {
          let row = this.currentAuthorityRow;
          let res = row.agencyId || row.applicationId || row.customerId || row.structureId;
          if (!res) {
            if (this.changeSaveRes) {
              this.saveType = 'add';
            } else {
              this.saveType = 'edit';
              this.changeSaveRes = true;
            }
          }
          switch (this.saveType) {
            case 'add':
              this.toSaveTableData.push(this.createAddOrEditObj('add'));
              break;
            case 'edit':
              this.toSaveTableData = this.toSaveTableData.map(i => {
                if (i.arrId === this.currentAuthorityRow.arrId) {
                  i = this.createAddOrEditObj('edit');
                  i.arrId = this.currentAuthorityRow.arrId;
                }
                return i;
              });
              break;
            default:
              break;
          }
          if (!this.continueState) {
            this.closeDepartmentVisible();
          } else {
            this.emptyForm();
          }
          this.$emit('onChangeSave', {
            data: this.toSaveTableData,
            authorityType: this.currentAuthorityRow.currentAuthorityTypeValue
          });
        }
      });
      if (this.showEmpty) {
        this.departmentVisible = false;
      }
    },
    // 获取部门父级name
    async getStructureName() {
      if (this.dataScopeForm.departmentValue) {
        let res = await getTreeName({
          customerId: this.$route.params.id.split(',')[1],
          structureId: this.dataScopeForm.departmentValue
        });
        this.structureName = res;
      } else {
        this.structureName = '';
      }
    },
    createAddOrEditObj(state) {
      let obj = {
        menuName: this.currentAuthorityRow.menuName,
        menuNameRowSpan: this.currentAuthorityRow.menuNameRowSpan,
        permissionsId: this.currentAuthorityRow.permissionsId,
        structureId: this.dataScopeForm.departmentValue,
        structureName: this.structureName,
        applicationId: this.dataScopeForm.applicationValue,
        appName: this.byIdSearchName(this.applicationSelectList, 'applicationValue', 'applicationId', 'name'),
        agencyId: this.dataScopeForm.intermediaryValue,
        agencyName: this.byIdSearchName(this.intermediarySelectList, 'intermediaryValue', 'id', 'name'),
        customerId: this.dataScopeForm.customerValue,
        customerName: this.byIdSearchName(this.customerSelectList, 'customerValue', 'id', 'name')
      };
      if (state === 'add') {
        return Object.assign(JSON.parse(JSON.stringify(obj)), {
          arrId: new Date().getTime()
        });
      }
      return obj;
    },
    byIdSearchName(list, value, id, name) {
      if (list.length && this.dataScopeForm[value]) {
        let returnName = list.find(i => i[id] === this.dataScopeForm[value])[name];
        return returnName;
      }
      return '';
    },
    emptyForm() {
      this.dataScopeForm.departmentValue = '';
      this.dataScopeForm.applicationValue = '';
      this.dataScopeForm.customerValue = '';
      this.dataScopeForm.intermediaryValue = '';
    },
    resetForm() {
      this.$refs.dataScopeRef && this.$refs.dataScopeRef.resetFields();
    },
    // 关闭选择弹窗
    closeDepartmentVisible() {
      this.departmentVisible = false;
      this.continueState = false;
      this.changeSaveRes = false;
      this.resetForm();
    },
    // 是否继续添加
    onContinueToAdd(e) {
      this.continueState = e.target.checked;
    },
    async getDepartmentAndApplicationData() {
      const customerId = this.$route.params.id.split(',')[1];
      const departmentRes = await structureList({
        customerId: Number(customerId)
      });
      if (departmentRes[0].children) {
        this.departmentSelectList = departmentRes[0].children;
      } else {
        this.departmentSelectList = [];
      }
    }
  }
};